export const gbMessages = {
  "footer.left.text": "Questions? {faqLink} or get in touch.",
  "links.faqsLink": "https://www.moneyfarm.com/uk/faqs/",
  "footer.left.readFaqs": "Read the FAQs",
  "footer.right.text":
    "{capitalAtRiskLink}: By making an investment, your capital is at risk.",
  "links.riskWarningLink": "https://www.moneyfarm.com/uk/risk-disclosure/",
  "footer.right.riskWarning": "Risk Warning",
  "footer.right.copyRight":
    "MFM Investment Ltd. Authorised and regulated by the FCA.",
  "contacts.phone": "08004334574",
  "contacts.email": "hello@moneyfarm.com",

  "page.serviceUnavailable.title":
    "Oh no! The service is currently unavailable",
  "page.serviceUnavailable.markdown": `Sorry, the service is undergoing maintenance and will be back in a few minutes.
    While you’re waiting probably you could take a look at our [blog](https://blog.moneyfarm.com) or our [youtube](https://www.youtube.com/c/MoneyfarmUK) channel`,
};
